<template>
<span>
  <span v-if="!this.likeOnly" class="actions" v-click-outside="hideSentiMenu">
    <span v-if="getLikeCount('Like') > 0">
      <i class="sentiment-button fa-thumbs-up fas icon like"></i>
      <div class="sentiment-counter like" @click="openSentiments('Like')">({{ getLikeCount('Like') }})</div>
    </span>
    <span v-if="getLikeCount('Thank') > 0">
      <i class="sentiment-button fa-award fas icon thank"></i>
      <div class="sentiment-counter like" @click="openSentiments('Thank')">({{ getLikeCount('Thank') }})</div>
    </span>
    <span v-if="getLikeCount('Love') > 0">
      <i class="sentiment-button fa-heart fas icon love"></i>
      <div class="sentiment-counter like" @click="openSentiments('Love')">({{ getLikeCount('Love') }})</div>
    </span>
    <div class="action sentiment-button like">
      <span :class="{ 'hide-sentiment-button': shouldDisplayAbove }">
        <i @click="toggleModal($event)"  class="sentiment-button fa-smile fas"></i>
      </span>
        <ul v-if="show_senti_menu" :class="{ 'modal-above': shouldDisplayAbove }" class="additional">
          <li @click="likeClicked('Like')" class="option">
            <i
                v-bind:class="{
                'fa-thumbs-up fas icon like': true,
                blob: like_clicked,
                pulse: like_clicked
              }"
            ></i>
            Like
          </li>
          <li @click="likeClicked('Thank')" class="option">
            <i class="fa-award fas icon thank"></i>
            Thank
          </li>
        </ul>
    </div>
  </span>
  <span v-if="this.likeOnly" class="actions"  >
    <span class="option">
      <i @click="likeClicked('Like')" class="sentiment-button fa-thumbs-up fas icon like" :style="{ opacity: getLikeCount('Like') > 0 ? 1 : 0.5 }"></i>
      <div v-if="getLikeCount('Like') > 0" class="sentiment-counter like" @click="openSentiments">({{ getLikeCount('Like') }})</div>
    </span>
  </span>
  </span>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { router } from "../common";
import clickOutside from '@/directives/v-click-outside';

export default {
  directives: {
    clickOutside
  },
  name: "Sentiments",
  props: ["messageId", "shareId", "likeOnly"],
  data() {
    return {
      show_senti_menu: false,
      // show_elip_menu: false,
      like_clicked: false,
      shouldDisplayAbove: false
      //show_like_only: this.likeOnly === true ? true : false
    };
  },
  created() {
    // Instead of fetching immediately, queue for batch fetch
    if (this.shareId) {
      this.queueShareIdForBatchFetch({ shareId: this.shareId });
    }
  },
  computed: {
    ...mapGetters("sentiments", ["likesByShareId", "likeCountsByShareId"]),

    getLikeCount() {
      return (type) => {
        const count = this.likeCountsByShareId(this.shareId + type);
        return count || 0; // Return 0 if undefined, null, or 0
      };
    }
  },

  methods: {
    ...mapActions("sentiments", [
      "likeContent",
      "fetchContentLikes",
      "fetchContentLikeCounts",
      "queueShareIdForBatchFetch"
    ]),

    likeClicked(likeType) {
      this.likeContent({ shareId: this.shareId, likeType});
      this.show_senti_menu = false;
      this.shouldDisplayAbove = false;
    },

    hideSentiMenu() {
      this.show_senti_menu = false
    },

    log(message) {
      this.$log.debug(message);
    },

    openSentiments(likeType) {
      var thePath = `/${this.$route.params.rallyId}/sentiments/${this.shareId}?likeType=${likeType}`
      if (this.$route.path != thePath) {
        router.push(thePath)
      }
    },
    toggleModal(event) {
      this.show_senti_menu = !this.show_senti_menu

      // Check if there's enough space below
      const button = event.target;
      const modalHeight = 200; // Let's assume your modal height or calculate it dynamically
      const spaceBelow = window.innerHeight - button.getBoundingClientRect().bottom;
      console.log("SHOULD DISPLAY AVOBE")
      this.shouldDisplayAbove = spaceBelow < modalHeight;
      console.log(this.shouldDisplayAbove)
    }
  }
};
</script>